module.exports = __webpack_public_path__ + "static/media/edit-pencil-white.c8323fdf.svg";